<template>
    <div :id="`lm-form-subtitles-builder-ui-${id}`" class="row">
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-6"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        :label="$t('desktop_view_width')"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
    <LmConditionalBuilderUi
      v-if="isVisibleCondition"
      class="col-12"
      :id="String(id)"
      :leftValueToCompareOptions="leftValueToCompareOptions"
      :visibilityDependOnConditions="visibilityDependOnConditions"
      @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
      @input="$emit('input', component)"
    />
    </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmConditionalBuilderUi from '@/components/lmFormBuilderUi/LmConditionalBuilderUi'
export default {
  data () {
    return {
      component: {
        class: 'col-12 col-md-6',
        componentName: 'LmFormEmptySpace'
      }
    }
  },
  components: {
    LmTextInput,
    LmSelect,
    LmConditionalBuilderUi
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    },
    visibilityDependOnConditions: {
      type: Object,
      default: () => ({
        isActive: false,
        conditions: []
      })
    },
    leftValueToCompareOptions: {
      type: Object,
      default: () => ({
        disabledOption: '',
        content: []
      })
    },
    id: {
      type: [String, Number],
      default: ''
    },
    componentData: {
      type: Object,
      default: () => (
        {
          class: 'col-12 col-md-6',
          componentName: 'LmFormEmptySpace',
          componentProps: {
            isVisible: true
          }
        }
      )
    }
  },
  created () {
    this.component = this.componentData
  }
}
</script>
